import type { SyncedLyricLine } from '../../services/sonosApi';

/** Índice de la línea activa: última con start_sec <= position + margen. */
export function findActiveLyricIndex(
  lines: SyncedLyricLine[],
  livePositionSec: number | null,
  marginSec = 0.25,
): number {
  if (!lines.length || livePositionSec == null || Number.isNaN(livePositionSec)) {
    return -1;
  }
  const t = livePositionSec + marginSec;
  let active = -1;
  for (let i = 0; i < lines.length; i += 1) {
    if (lines[i].start_sec <= t) active = i;
    else break;
  }
  return active;
}
